export default "__VITE_ASSET__6fMXd0lh__"